// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesUpsertApplicationGroupValidationError } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { firstLetterLowerCase } from './formattingHelpers';

export const formatBackendValidationErrors = (
  validationErrors: EndorsementServiceFeaturesUpsertApplicationGroupValidationError[]
) => {
  const fieldErrors: any = {};
  validationErrors?.forEach((e) => {
    if (e?.propertyName) {
      const splitField = e?.propertyName?.split('.') || [];
      let fieldName = splitField[splitField.length - 1];
      fieldName = firstLetterLowerCase(fieldName);

      // If it is an error in a list of items, add the indexed item to determine which one
      if (splitField[0].indexOf('Certificates[') !== -1) {
        const indexedItem = firstLetterLowerCase(splitField[0]);
        fieldName = `${indexedItem}.${fieldName}`;
      }
      fieldErrors[fieldName] = e.message || undefined;
    }
  });
  return fieldErrors;
};

export const isEmailInvalid = (val: string) => {
  return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);
};
